import { adminApiFetch } from '@services/admin/apiService'

export const fulfillmentService = {
  fetchList: async (params) => {
    try {
      const queryParams = new URLSearchParams();
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(v => queryParams.append(`${key}[]`, v));
          } else {
            queryParams.append(key, value);
          }
        });
      }
      const response = await adminApiFetch(`fulfillments?${queryParams.toString()}`, {
        method: 'GET',
      });
      const data = await response.json();
      if (data && data.data) {
        return { success: true, data: data.data };
      }
      return { success: false, message: 'Invalid response format' };
    } catch (error) {
      console.error('Fetch fulfillments error:', error);
      return { success: false, message: error.message };
    }
  },

  // 取得可合併的出貨單分組
  getMergeableGroups: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);

    const response = await adminApiFetch(`fulfillments/mergeable_groups?${queryParams.toString()}`, {
      method: 'GET'
    });
    return response.json();
  },

  merge: async (ids) => {
    try {
      const response = await adminApiFetch('fulfillments/merge', {
        method: 'POST',
        body: { ids }
      })
      const data = await response.json()
      if (!response.ok) {
        return { success: false, message: data?.message || data?.error || 'Merge failed' }
      }
      if (data) {
        return { success: true, data }
      }
      return { success: false }
    } catch (error) {
      console.error('Merge fulfillments error:', error)
      return { success: false, message: error.message }
    }
  },

  changeShippingType: async (id, shippingTypeId) => {
    try {
      const response = await adminApiFetch(`fulfillments/${id}/change_shipping_type`, {
        method: 'POST',
        body: { shipping_type_id: shippingTypeId }
      })
      const data = await response.json()
      if (!response.ok) {
        return { success: false, message: data?.message || 'Change shipping type failed' }
      }
      return { success: true, data }
    } catch (error) {
      console.error('Change shipping type error:', error)
      return { success: false, message: error.message }
    }
  }
}
